export default [
  {
    name: "Hasselquist, HS",
    id: "d5a3c022-2394-48b5-8f89-fac6a48bf419",
  },
  {
    name: "Belladonna, IKT",
    id: "a4ff7010-5ae9-46ec-87f9-a5fa22bc0892",
  },
  {
    name: "Valeriana",
    id: "19641b16-c840-4b43-bf78-46b97a26b182",
  },
  {
    name: "Digitalis",
    id: "85d55638-4a96-4ddb-be6e-ad3ac5d44396",
  },
  {
    name: "Papaver, IKT",
    id: "ccb3b1ed-613d-4079-a42b-5101929427e7",
  },
  {
    name: "Salix",
    id: "f7bebe9c-c885-426f-a9ab-7e6c2a695db1",
  },
  {
    name: "• Timjan",
    id: "1ff6ed16-d11d-430d-a22b-e82416e0a8b6",
  },
  {
    name: "Salvia",
    id: "d0197f41-2b11-4f6d-9587-bd913ade2fa3",
  },
  {
    name: "Mynta",
    id: "6ad2673c-7c75-409f-ab6c-8d15a073ec67",
  },
  {
    name: "Kanel",
    id: "587057c8-2a56-4b72-a793-35d702c04ec3",
  },
]; /* .map(({ name, id }) => ({
  name,
  id,
  locationId: locations.campusUS.house511.id
})) */
